var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheck2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M30 0C32.7618 0 35 2.2382 35 5L35 30C35 32.7618 32.7618 35 30 35L5 35C2.2382 35 0 32.7618 0 30L0 5C0 2.2382 2.2382 0 5 0L30 0Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L18 0L18 17.965L0 17.965L0 0Z",
    id: "path_2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Completado"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo-6-Copy"
  }, /*#__PURE__*/React.createElement("use", {
    stroke: "none",
    fill: "#FFFFFF",
    xlinkHref: "#path_1"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_1)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1",
    fill: "none",
    stroke: "#C6C6C6",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "check",
    transform: "translate(8.844727 9.000977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L18 0L18 17.965L0 17.965L0 0Z",
    id: "Fondo",
    fill: "#FFFFFF",
    fillOpacity: 0,
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.89253 15.7067C6.7207 15.8796 6.48628 15.976 6.24277 15.976C5.99926 15.976 5.76483 15.8796 5.59301 15.7067L0.403888 10.5168C-0.134629 9.97823 -0.134629 9.10499 0.403888 8.56749L1.05364 7.91756C1.59233 7.37904 2.46456 7.37904 3.00308 7.91756L6.24277 11.1574L14.9969 2.40314C15.5356 1.86462 16.4086 1.86462 16.9463 2.40314L17.5961 3.05306C18.1346 3.59158 18.1346 4.46465 17.5961 5.00233L6.89253 15.7067Z",
    id: "Forma",
    fill: "#C6C6C6",
    stroke: "none"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck2);
export default __webpack_public_path__ + "static/media/check-2.d4fa7462846bede22d7793a736b545c5.svg";
export { ForwardRef as ReactComponent };